export default __webpack_public_path__ + "static/media/social-play-white.73190993.png";